import { BasicLayout, RouteView } from '@/layouts'
import { Router } from './types'

export const example: Router = {
  path: '/',
  name: 'index',
  component: BasicLayout,
  meta: { title: 'menu.home' },
  redirect: '/ticket',
  children: [
    {
      path: '/ticket',
      name: 'ticket',
      component: () => import('@/views/ticket/index.vue'),
      hideChildrenInMenu: true,
      meta: { title: 'menu.ticket.management', icon: 'iconfont icon-shuju' },
      children: [
        {
          path: '/ticket/add',
          name: 'ticketAdd',
          component: () => import('@/views/ticket/add.vue'),
          meta: { title: 'menu.ticket.add', activeMenu: '/ticket' }
        },
        {
          path: '/ticket/edit/:id',
          name: 'ticketEdit',
          component: () => import('@/views/ticket/add.vue'),
          meta: { title: 'menu.ticket.edit', activeMenu: '/ticket' }
        },
        {
          path: '/ticket/session/:id',
          name: 'ticketSession',
          component: () => import('@/views/ticket/session.vue'),
          meta: { title: 'menu.ticket.session', activeMenu: '/ticket' }
        }
      ]
    },
    {
      path: '/order',
      name: 'order',
      component: () => import('@/views/order/index.vue'),
      hideChildrenInMenu: true,
      meta: { title: 'menu.order.management', icon: 'iconfont icon-shuju' },
      children: []
    },
    {
      path: '/artist',
      name: 'artist',
      component: () => import('@/views/artist/index.vue'),
      hideChildrenInMenu: true,
      meta: { title: 'menu.artist.management', icon: 'iconfont icon-bianjiwenzhang_huaban' },
      children: [
        {
          path: '/artist/add',
          name: 'artistAdd',
          component: () => import('@/views/artist/add.vue'),
          meta: { title: 'menu.artist.add', activeMenu: '/artist' }
        },
        {
          path: '/artist/edit/:id',
          name: 'artistEdit',
          component: () => import('@/views/artist/add.vue'),
          meta: { title: 'menu.artist.edit', activeMenu: '/artist' }
        }
      ]
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('@/views/userModel/index.vue'),
      meta: { title: 'menu.user.management', icon: 'iconfont icon-jiaoseguanli', keepAlive: true },
      hideChildrenInMenu: true,
      children: [
        {
          path: '/user/detail/:id',
          name: 'userDetail',
          component: () => import('@/views/userModel/detail.vue'),
          meta: { title: 'menu.user.managementDetail' }
        }
      ]
    },
    {
      path: '/character',
      name: 'character',
      component: () => import('@/views/character/index.vue'),
      hideChildrenInMenu: true,
      meta: { title: 'menu.system.character', icon: 'iconfont icon-shuju', keepAlive: true }
    },
    {
      path: '/dictionary',
      name: 'dictionary',
      component: () => import('@/views/dictionary/index.vue'),
      hideChildrenInMenu: true,
      meta: { title: 'menu.system.dictionary', icon: 'iconfont icon-zidianmokuai', keepAlive: true }
    },

    // exception
    {
      path: '/exception',
      name: 'exception',
      component: RouteView,
      redirect: '/exception/403',
      meta: { title: 'menu.exception.title', icon: 'bx-analyse' },
      hidden: true,
      children: [
        {
          path: '/exception/403',
          name: '403',
          component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/403.vue'),
          meta: { title: 'menu.exception.not-permission' }
        },
        {
          path: '/exception/404',
          name: '404',
          component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404.vue'),
          meta: { title: 'menu.exception.not-find' }
        },
        {
          path: '/exception/500',
          name: '500',
          component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/500.vue'),
          meta: { title: 'menu.exception.server-error' }
        }
      ]
    }
  ]
}
